export default __webpack_public_path__ + "static/media/logoIA.1890d4f7.png";